<template>

<DialogBox :settings="settings" :disabled="!isFormValid" @save="save" @show="showingDialog" @hide="hidingDialog">

        <div style="position:relative" class="pr-4 pl-4 pb-4">   
            <v-text-field v-model="team.name" label="Team Name" />
            <!-- <v-checkbox v-model="collection.logChanges" label="Log Changes" hide-details single-line /> -->
        </div>
  
</DialogBox>

</template>

<script>
import Vue from 'vue'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import MergeHelpers from '../helpers/MergeHelpers'
import FirebaseHelpers from '../helpers/FirebaseHelpers'
import DataHelpers from '../helpers/DataHelpers'
import LookupData from '../helpers/LookupData'
import StringHelpers from '../helpers/StringHelpers'
import Utilities from '../helpers/Utilities'

import DialogBox from '../ui-elements/DialogBox'
import ContactHelpers from '../helpers/ContactHelpers'


export default {
props:{
    settings: Object,
    team: Object,
},
components:{
    'DialogBox': DialogBox
},
data() {
    return {

    }
},
computed: {


    isFormValid() {
        return true
    }

    
},
methods: {

    save() {
        this.$emit('save', this.team)
        this.settings.visible = false
    },


    showingDialog() {

    },

    hidingDialog() {
        setTimeout( () => { 
            
        }, 300)            
    }

},

created() {
    this.settings.height = '350px'
},

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>


// WEBPACK FOOTER //
// TeamDialog.vue?47a1d69e